/* ============================================================================
   c-pv17.js  ·  PREVIEW THEME ONLY  ·  Claude, 16 Aug 2026 · BUILD r40
   PLACEHOLDER TRANSIT TABLE — replace before publishing. geojs = preview only.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__pv17) return;
  window.__pv17 = true;

  var BUILD = 'r40 r38 restored - r39 retracted';
  var CUTOFF_H = 14; /* 2:00 PM ET */

  var ZONES = {};
  ('FL:1:1 GA:1:2 AL:1:2 SC:2:2 NC:2:2 TN:2:2 MS:2:2 LA:2:3 KY:2:3 VA:2:3 ' +
   'AR:2:3 TX:2:4 WV:3:3 MD:3:3 DC:3:3 DE:3:3 PA:3:3 NJ:3:3 NY:3:3 CT:3:3 ' +
   'RI:3:3 MA:3:3 OH:3:3 IN:3:3 MI:3:3 IL:3:3 MO:3:3 VT:3:4 NH:3:4 ME:3:4 ' +
   'WI:3:4 OK:3:4 IA:3:4 MN:3:4 KS:3:4 NE:4:4 SD:4:4 CO:4:4 NM:4:4 ND:4:5 ' +
   'MT:4:5 WY:4:5 UT:4:5 AZ:4:5 NV:4:5 CA:4:5 ID:5:5 OR:5:5 WA:5:5'
  ).split(' ').forEach(function (t) {
    var p = t.split(':');
    ZONES[p[0]] = { lo: +p[1], hi: +p[2] };
  });

  var GEO = null;
  var CITY = null;
  var COUNTRY = null;

  function readCache() {
    try {
      var raw = sessionStorage.getItem('pv17geo');
      if (!raw) return false;
      var o = JSON.parse(raw);
      if (!o) return false;
      if (o.n) COUNTRY = o.n;
      if (ZONES[o.s] && o.c) { GEO = o.s; CITY = o.c; return true; }
      return !!o.n;
    } catch (e) { return false; }
  }
  function writeCache() {
    try { sessionStorage.setItem('pv17geo', JSON.stringify({ s: GEO, c: CITY, n: COUNTRY })); } catch (e) {}
  }
  var GEO_PROVIDERS = ['https://get.geojs.io/v1/ip/geo.json', 'https://ipapi.co/json/'];
  function lookupGeo(i) {
    i = i || 0;
    if (!window.fetch || i >= GEO_PROVIDERS.length) return;
    var dead = false;
    var t = setTimeout(function () { dead = true; lookupGeo(i + 1); }, 2500);
    fetch(GEO_PROVIDERS[i], { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        if (dead) return;
        clearTimeout(t);
        var st = ((j && j.region_code) || '').toUpperCase();
        var cc = ((j && j.country_code) || '').toUpperCase();
        if (cc && cc !== 'US') {
          COUNTRY = cc;
          writeCache();
          paintAll();
          return;
        }
        if (!j || cc !== 'US' || !j.city || !ZONES[st]) {
          lookupGeo(i + 1);
          return;
        }
        COUNTRY = 'US';
        GEO = st;
        CITY = j.city + ', ' + st;
        writeCache();
        paintAll();
      })
      .catch(function () {
        if (dead) return;
        clearTimeout(t);
        lookupGeo(i + 1);
      });
  }

  function etNow() {
    return new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' }));
  }
  function isBizDay(d) { return d.getDay() !== 0 && d.getDay() !== 6; }
  function shipsToday() {
    var now = etNow();
    return isBizDay(now) && now.getHours() < CUTOFF_H;
  }
  function fmt(d) { return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); }
  function fmtRange(a, b) {
    var m = function (x) { return x.toLocaleDateString('en-US', { month: 'short' }); };
    if (m(a) === m(b)) return m(a) + ' ' + a.getDate() + ' – ' + b.getDate();
    return m(a) + ' ' + a.getDate() + ' – ' + m(b) + ' ' + b.getDate();
  }
  function setHtml(el, h) { if (el && el.innerHTML !== h) el.innerHTML = h; }
  function setText(el, t) { if (el && el.textContent !== t) el.textContent = t; }
  function MOB() { return window.matchMedia('(max-width: 749px)').matches; }

  /* ---------- painters ------------------------------------------------------ */
  function paintInstock() {
    var el = document.querySelector('#instock');
    if (!el) return;
    var txt = el.querySelector('span');
    if (!txt) return;
    var msg = shipsToday()
      ? '<strong>In Stock</strong> • Ships today if ordered by 2:00 PM ET'
      : '<strong>In Stock</strong> • Ships next business day';
    setHtml(txt, msg);
  }

  function paintEstDate() {
    var wraps = document.querySelectorAll('.original-estdate-wrapper');
    if (!wraps.length) return;
    if (COUNTRY && COUNTRY !== 'US' && COUNTRY !== 'CA') {
      Array.prototype.forEach.call(wraps, function (el) { el.style.display = 'none'; });
      return;
    }
    var base = etNow();
    var lo, hi, city = '';
    var day = function (n) { var d = new Date(base.getTime()); d.setDate(d.getDate() + n); return d; };
    if (COUNTRY === 'CA') {
      lo = day(5); hi = day(10);
    } else if (GEO === 'FL' && CITY) {
      lo = day(1); hi = day(2);
      city = CITY;
    } else {
      lo = day(2); hi = day(5);
      if (GEO && CITY) city = CITY;
    }
    var range = (fmt(lo) === fmt(hi))
      ? lo.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' })
      : fmtRange(lo, hi);
    var html = '<div class="pv-est">' +
      '<span class="pv-estrow1"><span class="pv-estdot" aria-hidden="true"></span>' +
      '<span class="pv-esttxt"><b class="pv-estfree">FREE delivery</b>' +
      (city ? ' to ' + city : '') + '</span></span>' +
      '<strong class="pv-estarrive">Arrives ' + range + '</strong></div>';
    Array.prototype.forEach.call(wraps, function (el) {
      el.style.display = '';
      setHtml(el, html);
    });
  }

  function paintTierShipline() {
    var msg = shipsToday()
      ? '● In stock · ships today by 2:00 PM ET'
      : '● In stock · ships next business day';
    Array.prototype.forEach.call(document.querySelectorAll('[data-pv-shipline]'), function (el) {
      setText(el, msg);
    });
  }

  function tidyPrice() {
    var pr = document.querySelector('.product__info-container .price__regular');
    if (!pr) return;
    Array.prototype.forEach.call(pr.children, function (el) {
      if (el.classList && el.classList.contains('visually-hidden')) return;
      if (el.style.display === 'none') return;
      if (!el.textContent.replace(/\s+/g, '')) el.style.display = 'none';
    });
  }

  function qtyDropdown() {
    var wrap = document.querySelector('.product__info-container .product-form__quantity');
    if (!wrap || wrap.querySelector('.pv-qtysel')) return;
    var qi = wrap.querySelector('quantity-input');
    var input = wrap.querySelector('input.quantity__input');
    if (!qi || !input) return;
    var cur = parseInt(input.value, 10) || 1;
    var max = Math.max(10, cur);
    var box = document.createElement('div');
    box.className = 'select pv-qtysel';
    var sel = document.createElement('select');
    sel.className = 'select__select';
    sel.setAttribute('aria-label', 'Quantity');
    for (var i = 1; i <= max; i++) {
      var o = document.createElement('option');
      o.value = String(i);
      o.textContent = String(i);
      if (i === cur) o.selected = true;
      sel.appendChild(o);
    }
    sel.addEventListener('change', function () {
      input.value = sel.value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    box.appendChild(sel);
    var caret = document.createElement('span');
    caret.className = 'svg-wrapper';
    caret.innerHTML = '<svg width="12" height="8" viewBox="0 0 12 8" fill="none" aria-hidden="true"><path d="M1.5 1.75 L6 6.25 L10.5 1.75" stroke="#14171A" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    box.appendChild(caret);
    qi.insertAdjacentElement('afterend', box);
    qi.classList.add('pv-qhide');
  }

  function prefetchAddons() {
    Array.prototype.forEach.call(document.querySelectorAll('.c-upsell-item'), function (row) {
      if (row.dataset.pvAddScan) return;
      row.dataset.pvAddScan = '1';
      var idInput = row.querySelector('.quick-add input[name="id"], product-form input[name="id"]');
      var hasModal = !!row.querySelector('modal-opener');
      if (idInput && !hasModal) { row.dataset.pvSingle = '1'; markAddonConfig(); return; }
      var a = row.querySelector('a[href*="/products/"]');
      if (!a || !window.fetch) return;
      var handle = (a.getAttribute('href').split('/products/')[1] || '').split('?')[0].split('#')[0].replace(/\/+$/, '');
      if (!handle) return;
      fetch('/products/' + handle + '.js', { credentials: 'omit' })
        .then(function (r) { return r.json(); })
        .then(function (p) {
          if (p && p.variants && p.variants.length === 1) {
            row.dataset.pvSingle = '1';
            markAddonConfig();
          }
        })
        .catch(function () {});
    });
  }

  function refreshDrawer(openIt) {
    var url = (window.routes && window.routes.cart_url) || '/cart';
    return fetch(url + '?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (t) {
        var html = new DOMParser().parseFromString(t, 'text/html');
        var root = document.getElementById('CartDrawer');
        if (!root) return;
        ['cart-drawer-items', '.cart-drawer__footer', '.drawer__header'].forEach(function (sel) {
          var src = html.querySelector(sel);
          var dst = root.querySelector(sel);
          if (src && dst) dst.replaceWith(src);
        });
        var dr = document.querySelector('cart-drawer');
        if (dr) {
          var srcDrawer = html.querySelector('cart-drawer');
          if (srcDrawer && srcDrawer.classList.contains('is-empty')) dr.classList.add('is-empty');
          else dr.classList.remove('is-empty');
          if (openIt) {
            if (typeof dr.open === 'function') dr.open();
            else dr.classList.add('animate', 'active');
          }
        }
        paintAll();
      });
  }

  /* r30 THE CART ICON: the theme renders TWO elements with id=cart-icon-bubble
     (hidden menu item first, visible a.bo-cart second). Dawn binds its drawer
     opener to the FIRST match, so the visible icon navigated to /cart instead.
     Delegated capture handler owns both. AT PUBLISH: de-duplicate the id. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#cart-icon-bubble, a.bo-cart');
    if (!a) return;
    var dr = document.querySelector('cart-drawer');
    if (!dr) return;
    e.preventDefault();
    e.stopPropagation();
    var menu = a.closest('header-drawer');
    if (menu) {
      var det = menu.querySelector('details[open]');
      if (det) det.removeAttribute('open');
      document.body.classList.remove('overflow-hidden');
    }
    if (!dr.classList.contains('active')) refreshDrawer(true);
  }, true);

  /* r31 THE COUNT: /cart.js is the only source of truth. r30 summed the
     rendered drawer, which is only as fresh as the page HTML — an iOS
     back/forward-cache restore served yesterday's markup and the badge locked
     onto it. Confirmed fixed by Jacob; text only, cannot move the drawer. */
  var CART_N = null;
  var syncBusy = false;
  var syncAt = 0;
  var mismatchTries = 0;

  /* ==========================================================================
     r36 kept: ?pvdebug=1 draws a live panel on the device. Without the query
     parameter nothing is created and nothing renders — real traffic untouched.
     ========================================================================== */
  var PVDBG = null;
  function dbg(k, v) {
    if (!PVDBG) return;
    PVDBG.data[k] = v;
    var s = [];
    for (var i in PVDBG.data) s.push(i + ': ' + PVDBG.data[i]);
    PVDBG.el.textContent = s.join('\n');
  }
  function initDebug() {
    if (PVDBG || location.search.indexOf('pvdebug') === -1 || !document.body) return;
    var box = document.createElement('div');
    box.setAttribute('style', 'position:fixed;left:6px;top:6px;z-index:2147483647;' +
      'background:rgba(0,0,0,.87);color:#3f6;font:600 10px/1.4 ui-monospace,Menlo,monospace;' +
      'padding:7px 9px;border-radius:8px;max-width:80vw;pointer-events:none;white-space:pre-wrap');
    document.body.appendChild(box);
    PVDBG = { el: box, data: {} };
    dbg('build', BUILD);
  }

  /* ==========================================================================
     r37 — THE EXEMPTION WAS THE BUG

     r36's panel on Jacob's phone reported, verbatim:
         guard: installed @document capture
         touch: DRAWER / list
         pageY start: 968
     and NO 'blocked' line at all.

     The guard installed and ran, then deliberately stood down, because r35/r36
     exempted any touch starting inside .drawer__contents on the assumption that
     the list scrolls itself natively. That is only true when the list actually
     overflows. With one item it does NOT overflow: it is a non-scrollable
     element, overscroll-behavior has nothing to contain, and the drag walks
     straight up to the document — which pageY start: 968 proves was unlocked
     and mid-scroll behind the drawer. Same thing at either end of a full list.

     It also corrects the region. We both blamed the footer. The footer was never
     the entry point; the list was, and the guard was written to ignore it.

     Fix: exempt the list only for the frames where it can genuinely consume the
     gesture — it overflows AND is not already against the boundary in the drag
     direction. Every other frame is cancelled. Event-level only: no sizing, no
     viewport measurement, no geometry. Cannot move a pixel, per the r33 rule.
     ========================================================================== */
  var blocked = 0;
  function scrollerFor(t) {
    var el = t;
    while (el && el.nodeType === 1) {
      if (el.id === 'CartDrawer') return null;
      if (el.scrollHeight - el.clientHeight > 1) {
        var oy = '';
        try { oy = getComputedStyle(el).overflowY; } catch (e) {}
        if (oy === 'auto' || oy === 'scroll') return el;
      }
      el = el.parentElement;
    }
    return null;
  }
  function canTake(el, dy) {
    if (!el) return false;
    var max = el.scrollHeight - el.clientHeight;
    if (max <= 1) return false;
    var top = el.scrollTop;
    if (dy > 0 && top >= max - 1) return false; /* finger up, already at bottom */
    if (dy < 0 && top <= 0) return false;       /* finger down, already at top  */
    return true;
  }
  function installGestureGuard() {
    if (window.__pvGuard) return;
    window.__pvGuard = 1;
    var inDrawer = false, scroller = null, ty0 = 0, yStart = 0;
    document.addEventListener('touchstart', function (e) {
      var t = e.target;
      inDrawer = !!(t && t.closest && t.closest('#CartDrawer'));
      scroller = inDrawer ? scrollerFor(t) : null;
      ty0 = (e.touches && e.touches[0]) ? e.touches[0].clientY : 0;
      yStart = window.pageYOffset || 0;
      dbg('touch', inDrawer ? 'DRAWER' : 'page');
      dbg('scroller', !scroller ? 'NONE - guard owns this drag'
        : (scroller.className || scroller.tagName) + '  ' +
          Math.round(scroller.scrollTop) + '/' + Math.round(scroller.scrollHeight - scroller.clientHeight));
      dbg('pageY start', Math.round(yStart));
    }, { capture: true, passive: true });
    document.addEventListener('touchmove', function (e) {
      if (!inDrawer) return;
      if (e.touches && e.touches.length > 1) return; /* never fight a pinch */
      var ty = (e.touches && e.touches[0]) ? e.touches[0].clientY : ty0;
      var dy = ty0 - ty;
      if (canTake(scroller, dy)) {
        dbg('verdict', 'native (list has room, dy ' + Math.round(dy) + ')');
      } else {
        if (e.cancelable) { e.preventDefault(); blocked++; }
        dbg('verdict', 'BLOCKED ' + blocked + ' (dy ' + Math.round(dy) +
          ', cancelable ' + e.cancelable + ')');
      }
      var now = Math.round(window.pageYOffset || 0);
      dbg('pageY now', now + (now !== Math.round(yStart) ? '  <-- PAGE MOVED' : '  (held)'));
      var inner = document.querySelector('#CartDrawer .drawer__inner');
      if (inner) dbg('drawerH', Math.round(inner.getBoundingClientRect().height) + ' / vp ' + window.innerHeight);
    }, { capture: true, passive: false });
    dbg('guard', 'installed @document capture');
  }

  function drawerSum() {
    var dr = document.querySelector('cart-drawer');
    if (!dr) return null;
    if (dr.classList.contains('is-empty')) return 0;
    var inputs = document.querySelectorAll('#CartDrawer .quantity__input');
    if (!inputs.length) return null;
    var n = 0;
    Array.prototype.forEach.call(inputs, function (i) { n += parseInt(i.value, 10) || 0; });
    return n;
  }

  function paintBadges() {
    var n = (CART_N === null) ? drawerSum() : CART_N;
    if (n === null) return;
    Array.prototype.forEach.call(document.querySelectorAll('.bo-cart__count'), function (el) {
      setText(el, String(n));
      el.style.display = n ? '' : 'none';
    });
    Array.prototype.forEach.call(document.querySelectorAll('.cart-count-bubble'), function (b) {
      setHtml(b, '<span aria-hidden="true">' + n + '</span>' +
        '<span class="visually-hidden">' + n + ' item' + (n === 1 ? '' : 's') + '</span>');
      b.style.display = n ? '' : 'none';
    });
    var hc = document.querySelector('#CartDrawer .pv-hcount');
    if (hc) setText(hc, n + ' item' + (n === 1 ? '' : 's'));
  }

  function syncCart(force) {
    if (!window.fetch || syncBusy) return;
    var now = new Date().getTime();
    if (!force && now - syncAt < 1200) return;
    syncBusy = true;
    syncAt = now;
    fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        if (!c || typeof c.item_count !== 'number') return;
        CART_N = c.item_count;
        paintBadges();
        var shown = drawerSum();
        if (shown !== null && shown !== CART_N) {
          if (mismatchTries < 3) { mismatchTries++; refreshDrawer(false); }
        } else {
          mismatchTries = 0;
        }
      })
      .catch(function () {})
      .then(function () { syncBusy = false; });
  }

  /* ---------- the drawer is r30's drawer: nothing here sizes or moves it ----- */

  /* r38 — REMOVED: the one-click direct-add handler.

     It matched any button / modal-opener / label / .c-slider / [role=button]
     inside an add-on row whose product had a single variant, then called
     preventDefault() + stopPropagation() and POSTed that variant to
     /cart/add.js on its own, followed by refreshDrawer(true).

     Three failures, all reported live on the 2" Pod Light PDP (Aug 16), where
     2 of 4 add-on rows qualified (2-Piece Connect Cable, 12V Socket Harness):

       1. The row is a <label> wrapping the hidden .c-product-upsell-id
          checkbox. preventDefault() stopped that checkbox from ever ticking,
          so the add-on module's own "add it with the main product" mechanism
          was bypassed entirely.
       2. Only the accessory went into the cart. The product the shopper was
          actually looking at did not — a $40 cable alone, which reads as a
          broken cart.
       3. refreshDrawer(true) threw the drawer open, yanking the shopper off
          the PDP before they had added anything they came for.

     It also inflated add-to-cart (an accessory add fires the same event) while
     poisoning cart-to-order. Both v17 test metrics were exposed to this.

     The fix is deletion, not replacement: the checkbox already does the right
     thing. Click the pill -> checkbox ticks -> pill reads "Added" -> the
     add-on goes in together with the main product on Add to Cart, and nothing
     navigates. Multi-variant add-ons still route through the modal, exactly as
     the live theme does. VERIFIED with trusted clicks 25 Aug 2026 (r40). */

  function ensurePlay(v) {
    if (!v) return;
    if (!v.__pvInit) {
      v.__pvInit = 1;
      v.muted = true;
      v.setAttribute('muted', '');
      v.setAttribute('playsinline', '');
      v.playsInline = true;
      v.loop = true;
      v.addEventListener('click', function () {
        if (v.paused) {
          v.muted = true;
          var p2 = v.play();
          if (p2 && p2.catch) p2.catch(function () { v.controls = true; });
        }
      });
    }
    if (!v.paused) return;
    v.muted = true;
    var p = v.play();
    if (p && p.catch) p.catch(function () { v.controls = true; });
  }
  function loadDeferred(dm) {
    if (!dm) return null;
    if (!dm.getAttribute('loaded')) {
      if (typeof dm.loadContent === 'function') {
        try { dm.loadContent(false); } catch (e) {}
      }
      if (!dm.getAttribute('loaded')) {
        var tpl = dm.querySelector('template');
        if (tpl && tpl.content && tpl.content.firstElementChild) {
          dm.appendChild(tpl.content.firstElementChild.cloneNode(true));
          dm.setAttribute('loaded', 'true');
        }
      }
    }
    return dm.querySelector('video, iframe');
  }
  function ensureIframe(scope) {
    if (!scope || !scope.querySelector) return;
    var f = scope.querySelector('iframe[src*="youtube"], iframe[src*="youtu.be"], iframe[src*="vimeo"]');
    if (!f || f.__pvA) return;
    f.__pvA = 1;
    var src = f.getAttribute('src') || '';
    if (!src) return;
    var sep = src.indexOf('?') > -1 ? '&' : '?';
    if (src.indexOf('vimeo') > -1) {
      f.setAttribute('src', src + sep + 'autoplay=1&muted=1&playsinline=1&loop=1');
    } else {
      f.setAttribute('src', src + sep + 'autoplay=1&mute=1&playsinline=1&controls=1');
    }
  }

  function galleryVideoIO(entries) {
    entries.forEach(function (en) {
      var t = en.target;
      var v = t.tagName === 'VIDEO' ? t : t.querySelector('video');
      if (en.isIntersecting && en.intersectionRatio >= 0.6) {
        if (t.querySelector) loadDeferred(t.querySelector('deferred-media'));
        setTimeout(function () {
          ensurePlay(t.tagName === 'VIDEO' ? t : t.querySelector('video'));
          ensureIframe(t);
        }, 120);
      } else if (v && !v.paused && en.intersectionRatio < 0.35) {
        /* r28 hysteresis: play at >=60%, pause only under 35% */
        v.pause();
      }
    });
  }
  function initMediaAutoplay() {
    if (!window.IntersectionObserver) return;
    if (!window.__pvIO) {
      window.__pvIO = new IntersectionObserver(galleryVideoIO, { threshold: [0, 0.35, 0.6] });
    }
    var watch = function (el) {
      if (el.__pvObs) return;
      el.__pvObs = true;
      window.__pvIO.observe(el);
    };
    Array.prototype.forEach.call(
      document.querySelectorAll('.product__media-list .product__media-item'), watch);
    Array.prototype.forEach.call(document.querySelectorAll('video'), function (v) {
      if (v.closest('.product__media-list') || v.closest('.quick-add-modal') ||
          v.closest('#CartDrawer')) return;
      watch(v);
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.quick-add-modal, product-modal, #CartDrawer')) return;
    if (e.target.closest('video, iframe')) return;
    var slide = e.target.closest('.product__media-item, .product-media-container');
    var dm = slide && slide.querySelector('deferred-media');
    if (dm) {
      var v = loadDeferred(dm);
      if (v && v.tagName === 'VIDEO' && v.paused) ensurePlay(v);
      ensureIframe(dm);
      return;
    }
    var gv = slide && slide.querySelector('video.pv-gvid');
    if (gv) {
      if (gv.paused) ensurePlay(gv);
      return;
    }
    var hit = e.target.closest(
      '.product__modal-opener, .product__media-toggle, .product__media-icon, .product__media-zoom');
    if (!hit) return;
    var box = hit.closest('.product-media-container') || hit.closest('.product__media-item');
    var btn = (hit.getAttribute && hit.getAttribute('data-media-id'))
      ? hit
      : (box && box.querySelector('.product__media-toggle[data-media-id]'));
    if (!btn) return;
    setTimeout(function () {
      var modal = document.querySelector('product-modal, #ProductModal, .product-media-modal');
      if (!modal) return;
      var isOpen = modal.hasAttribute('open') || modal.classList.contains('open');
      if (!isOpen && typeof modal.show === 'function') {
        try { modal.show(btn); } catch (err) {}
      }
      if (modal.hasAttribute('open') && !modal.querySelector('[data-media-id].active')) {
        var m = modal.querySelector('[data-media-id="' + btn.getAttribute('data-media-id') + '"]')
          || modal.querySelector('.product-media-modal__content [data-media-id]');
        if (m) {
          m.classList.add('active');
          if (m.scrollIntoView) try { m.scrollIntoView(); } catch (err) {}
        }
      }
    }, 80);
  });

  var CART_ICON_FALLBACK = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-cart" viewBox="0 0 40 40"><path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 0 0-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0 0 20.5 6.5m3.75 5.31v-.56a3.75 3.75 0 1 0-7.5 0v.56zm-7.5 1h7.5v.56a3.75 3.75 0 1 1-7.5 0zm-1 0v.56a4.75 4.75 0 1 0 9.5 0v-.56h2.22l.71 10.67a4 4 0 0 1-3.99 4.27h-7.38a4 4 0 0 1-4-4.27l.72-10.67z"/></svg>';
  var CART_ICON_HTML = null;
  function fixHeaderCart() {
    var link = document.querySelector('a#cart-icon-bubble');
    if (!link) return;
    var sw = link.querySelector('.svg-wrapper');
    if (!sw) return;
    var isText = /My Cart/i.test(sw.textContent);
    if (CART_ICON_HTML === null && !isText) CART_ICON_HTML = sw.innerHTML;
    if (isText) setHtml(sw, CART_ICON_HTML || CART_ICON_FALLBACK);
  }

  function modalFit() {
    var dlg = document.querySelector('.quick-add-modal[open]');
    if (!dlg) return;
    var content = dlg.querySelector('.quick-add-modal__content');
    var info = dlg.querySelector('.quick-add-modal__content-info');
    if (!content || !info) return;
    var top = content.getBoundingClientRect().top;
    var maxB = 0;
    Array.prototype.forEach.call(info.querySelectorAll('*'), function (k) {
      var cs = getComputedStyle(k);
      if (cs.display === 'none' || cs.visibility === 'hidden' || cs.position === 'fixed') return;
      var r = k.getBoundingClientRect();
      if (r.height > 2 && r.bottom > maxB && r.bottom < window.innerHeight * 2) maxB = r.bottom;
    });
    if (!maxB) return;
    var want = Math.min(maxB - top + 16, window.innerHeight * 0.88);
    var cur = content.getBoundingClientRect().height;
    if (Math.abs(cur - want) > 24) {
      content.style.setProperty('height', want + 'px', 'important');
      content.style.setProperty('max-height', want + 'px', 'important');
    }
  }

  function activeSlideVideo() {
    if (!MOB()) return;
    var list = document.querySelector('.product__media-list');
    if (list && !list.__pvScroll) {
      list.__pvScroll = 1;
      var tmr = null;
      list.addEventListener('scroll', function () {
        clearTimeout(tmr);
        tmr = setTimeout(playCentered, 160);
      }, { passive: true });
      list.addEventListener('touchend', function () {
        var items = list.querySelectorAll('.product__media-item');
        var cx = window.innerWidth / 2;
        Array.prototype.forEach.call(items, function (it) {
          var r = it.getBoundingClientRect();
          if (r.width === 0 || r.left > cx || r.right < cx) return;
          loadDeferred(it.querySelector('deferred-media'));
          ensurePlay(it.querySelector('video'));
        });
      }, { passive: true });
    }
    playCentered();
  }
  function playCentered() {
    var items = document.querySelectorAll('.product__media-list .product__media-item');
    var cx = window.innerWidth / 2;
    Array.prototype.forEach.call(items, function (it) {
      var r = it.getBoundingClientRect();
      if (r.width === 0) return;
      var centered = r.left <= cx && r.right >= cx;
      var v = it.querySelector('video');
      if (centered) {
        loadDeferred(it.querySelector('deferred-media'));
        setTimeout(function () {
          ensurePlay(it.querySelector('video'));
          ensureIframe(it);
        }, 120);
      } else if (v && !v.paused) {
        v.pause();
      }
    });
    var pm = document.querySelector('product-modal[open], .product-media-modal[open]');
    if (pm) {
      Array.prototype.forEach.call(pm.querySelectorAll('video'), ensurePlay);
    }
  }

  /* r18b: re-render only the list CONTENTS, footer and header — the live
     scroll container itself survives, which was the drawer scroll-lock fix */
  function patchDrawerSections() {
    var CD = customElements.get('cart-drawer-items');
    if (!CD || CD.__pvPatched) return;
    CD.__pvPatched = true;
    CD.prototype.getSectionsToRender = function () {
      return [
        { id: 'CartDrawer-CartItems', section: 'cart-drawer', selector: '.js-contents' },
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.cart-drawer__footer' },
        { id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__header' }
      ];
    };
  }

  function markAddonConfig() {
    Array.prototype.forEach.call(document.querySelectorAll('.c-upsell-item'), function (row) {
      /* r40 - RESTORES r38 verbatim. r39 was my error and it is retracted.

         r39 deleted this block on the strength of a scripted test in which the
         accessory failed to attach. That test was invalid: it called
         element.click() from JavaScript, which ticks the checkbox but does not
         satisfy the add-on module's own handler. Re-run with real trusted
         browser clicks on 25 Aug 2026, r38's behaviour is correct:

           one POST /cart/add.js
           {"items":[{"id":"10719945284","quantity":1},
                     {"id":"25532700360","quantity":1}]}
           cart: 2 Inch Marine LED Pod Light $135 + 2-Piece Connect Cable $40

         Main product and accessory, bundled, one add-to-cart event. This is
         the behaviour Jacob specified on Aug 16 and it has been working since.

         DO NOT re-test this path with element.click(), .dispatchEvent(), or any
         synthetic event. It will appear broken and it is not. Use a trusted
         click (the browser driver, or a human on a device).

         An add-on with exactly one variant has nothing to configure, so its
         pill reads "Add" -> "Added", not "Options". prefetchAddons() stamps
         data-pv-single on those rows and calls us back. */
      var needs = !row.dataset.pvSingle &&
        !!row.querySelector('modal-opener .quick-add__submit, .quick-add modal-opener');
      row.classList.toggle('pv-needs-config', needs);

      /* And it must not open the quick-add modal either. Ticking the row's
         checkbox makes the add-on module click the hidden .quick-add__submit,
         which is a Dawn <modal-opener> trigger. For a single-variant add-on
         there is nothing in that modal to choose, so it is pure interruption.
         Replacing the button with a clone drops Dawn's click listener; the
         checkbox still ticks, the pill still reads "Added", and the add-on
         still goes into the cart with the main product on Add to Cart.
         Multi-variant rows keep their modal. */
      if (row.dataset.pvSingle) {
        /* NB: a row carries TWO <modal-opener> elements - one around the title
           <h3>, one around the hidden submit. Only the second one has a button
           for Dawn to bind to, so select on the button, not the wrapper. Flag
           first, then clone: the clone inherits the attribute, so this runs
           exactly once per row. */
        var mb = row.querySelector('modal-opener .quick-add__submit');
        if (mb && !mb.dataset.pvNoModal && mb.parentNode) {
          mb.dataset.pvNoModal = '1';
          mb.parentNode.replaceChild(mb.cloneNode(true), mb);
        }
      }
    });
  }

  function moveTrust() {
    var anchor = document.querySelector('.c-buyButton');
    if (!anchor) return;
    var order = [];
    var est = document.querySelector('.original-estdate-wrapper');
    if (est && MOB()) order.push(est);
    var payImg = document.querySelector('.product-custom_images img[alt*="ayment" i], .product__info-container img[alt*="ayment" i]');
    if (payImg && MOB()) {
      var payBox = payImg.closest('.image') || payImg.closest('.rte.c-rte_images') || payImg.parentElement;
      if (payBox && payBox !== anchor.parentNode) order.push(payBox);
    }
    var t = document.querySelector('.pv-trust[data-pv-move-after]');
    if (t) order.push(t);
    var prev = anchor;
    order.forEach(function (el) {
      if (prev.nextElementSibling !== el) prev.parentNode.insertBefore(el, prev.nextSibling);
      prev = el;
    });
  }
  function suppressLegacyTrust() {
    Array.prototype.forEach.call(document.querySelectorAll('.product-custom_images img'), function (im) {
      var alt = (im.getAttribute('alt') || '').toLowerCase();
      var box = im.closest('.image');
      if (!box) return;
      if (alt.indexOf('warrant') > -1 || alt.indexOf('money') > -1 ||
          alt.indexOf('30 day') > -1 || alt.indexOf('life time') > -1 || alt.indexOf('lifetime') > -1) {
        box.classList.add('pv-legacy-trust');
      }
    });
    var phone = document.querySelector('.mobile-only-show-block');
    if (phone) phone.classList.add('pv-legacy-trust');
  }

  var discBusy = false;
  function drawerDiscount() {
    if (discBusy) return;
    var sub = document.querySelector('.cart-drawer__footer .sub-totals .totals__total-value');
    var tot = document.querySelector('.cart-drawer__footer .grand_total .totals__total-value');
    if (!sub || !tot) return;
    var num = function (el) { return parseFloat(String(el.textContent).replace(/[^0-9.]/g, '')) || 0; };
    var save = num(sub) - num(tot);
    var row = document.querySelector('.pv-disc-row');
    discBusy = true;
    try {
      if (save <= 0.009) { if (row) row.parentNode.removeChild(row); return; }
      var want = '-$' + save.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
      if (!row) {
        row = document.createElement('div');
        row.className = 'totals pv-disc-row';
        row.innerHTML = '<h2 class="totals__total">Discount</h2><p class="totals__total-value"></p>';
        var g = tot.closest('.grand_total');
        g.parentNode.insertBefore(row, g);
      }
      setText(row.querySelector('.totals__total-value'), want);
    } finally {
      setTimeout(function () { discBusy = false; }, 120);
    }
  }

  function drawerV16() {
    var foot = document.querySelector('.cart-drawer__footer');
    if (!foot) return;
    var sub = foot.querySelector('.sub-totals .totals__total-value');
    if (!sub) return;
    var num = parseFloat(String(sub.textContent).replace(/[^0-9.]/g, '')) || 0;
    var unlocked = num > 50;
    var line = foot.querySelector('.pv-freeship');
    if (unlocked && !line) {
      line = document.createElement('div');
      line.className = 'pv-freeship';
      line.innerHTML = '<span>✓</span> Free shipping unlocked';
      foot.insertBefore(line, foot.firstChild);
    } else if (!unlocked && line) {
      line.parentNode.removeChild(line);
    }
    var shipRow = foot.querySelector('.pv-ship-row');
    if (unlocked && !shipRow) {
      shipRow = document.createElement('div');
      shipRow.className = 'totals pv-ship-row';
      shipRow.innerHTML = '<h2 class="totals__total">Shipping</h2><p class="totals__total-value">FREE</p>';
      var g = foot.querySelector('.grand_total');
      if (g) g.parentNode.insertBefore(shipRow, g);
    } else if (!unlocked && shipRow) {
      shipRow.parentNode.removeChild(shipRow);
    }
  }

  function watchDrawer() {
    var dr = document.querySelector('cart-drawer');
    if (!dr || !window.MutationObserver) return;
    new MutationObserver(function () {
      var open = dr.classList.contains('active') || dr.classList.contains('animate');
      document.body.classList.toggle('pv-drawer-open', open);
      dbg('drawer', open ? 'OPEN' : 'closed');
      if (open) setTimeout(function () {
        drawerDiscount(); drawerV16(); syncCart(true);
      }, 350);
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }

  function dedupeTrustmark() {
    var col = document.querySelector('.product__info-container');
    if (!col) return;
    var marks = col.querySelectorAll(
      '.trusted_site, [id^="trustedsite-tm"], img[src*="trustedsite" i], img[alt*="trusted" i], img[alt*="mcafee" i]');
    for (var i = 1; i < marks.length; i++) marks[i].style.display = 'none';
  }

  function reviewsLink() {
    var badge = document.querySelector(
      '.product__info-container .stamped-product-reviews-badge, ' +
      '.product__info-container .stamped-badge, ' +
      '.product__info-container [class*="reviews-badge"]');
    if (!badge || badge.classList.contains('pv-rev-link')) return;
    badge.classList.add('pv-rev-link');
    badge.addEventListener('click', function () {
      var w = document.querySelector('#stamped-main-widget, .stamped-main-widget, ' +
        '#stamped-reviews-widget, [id*="stamped"][class*="widget"]');
      if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- paint scheduling ---------------------------------------------- */
  /* r36: each painter is isolated. Before this, one painter throwing on iOS
     silently disabled every painter after it for the life of the page. A
     failure is now contained to its own step, and ?pvdebug=1 names it. */
  var PAINTERS = [
    paintInstock, paintEstDate, paintTierShipline, tidyPrice, qtyDropdown,
    prefetchAddons, initMediaAutoplay, activeSlideVideo, fixHeaderCart,
    paintBadges, modalFit, patchDrawerSections, markAddonConfig,
    dedupeTrustmark, reviewsLink, drawerDiscount, drawerV16, moveTrust,
    suppressLegacyTrust
  ];
  function paintAll() {
    for (var i = 0; i < PAINTERS.length; i++) {
      try { PAINTERS[i](); }
      catch (e) { dbg('painter error', (PAINTERS[i].name || i) + ': ' + (e && e.message)); }
    }
  }
  var timers = [];
  function repaintSoon() {
    timers.forEach(clearTimeout); timers = [];
    [80, 350, 800].forEach(function (ms) { timers.push(setTimeout(paintAll, ms)); });
  }

  function boot() {
    window.__pv17v = BUILD;

    /* instrumentation and the gesture guard go FIRST, before any painter can
       throw. The guard is the one thing that must never fail to install. */
    initDebug();
    installGestureGuard();

    if (!readCache()) lookupGeo();
    paintAll();
    watchDrawer();
    syncCart(true);
    var drawerEl = document.querySelector('cart-drawer');
    if (drawerEl && window.MutationObserver) {
      var pending = null;
      new MutationObserver(function () {
        clearTimeout(pending);
        pending = setTimeout(function () {
          drawerDiscount(); drawerV16(); syncCart(true);
        }, 200);
      }).observe(drawerEl, { childList: true, subtree: true });
    }
    document.addEventListener('change', repaintSoon);
    window.addEventListener('resize', repaintSoon);
    window.addEventListener('pageshow', function (e) {
      if (e && e.persisted) { CART_N = null; mismatchTries = 0; }
      syncCart(true);
    });
    window.addEventListener('focus', function () { syncCart(); });
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) syncCart(true);
    });
    /* NO visualViewport listeners, NO scroll lock, NO sizing — r30 geometry. */
    setInterval(function () { syncCart(); }, 15000);
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var el = muts[i].target;
          if (el.classList && el.classList.contains('quick-add-modal') && el.hasAttribute('open')) {
            modalFit();
            setTimeout(modalFit, 120);
            setTimeout(modalFit, 350);
            break;
          }
        }
      }).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open'] });
    }
    setInterval(paintAll, 2500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
